import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('sales', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        show: (cntx, { id }) => {
            axios.get(`sales/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        },
        showSaleNumber: (cntx, { id }) => {
            axios.get(`markets/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        },
        create: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('sales', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        update: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`sales/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        updateStack: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`associate_grades/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        remove: (cntx, id) => new Promise((resolve, reject) => {
            axios.delete(`associate_grades/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        levels: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('levels', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        locations: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('locations', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        seasons: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('seasons', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        buyers: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('buyers', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        grades: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('groups', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        getWarehouse: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('warehouses_micro', {
                params: {
                    location_id: params.location_id,
                    storage_only: params.storage_only,
                },
            })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        getStack: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('warehouses_min', {
                params: {
                    warehouse_id: params.warehouse_id,
                },
            })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        societies: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('societies', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        transporters: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('transporters', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        emptyStack: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('empty_stack', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
